import { useNavigate } from "react-router-dom";
import { Button, Card, Grid, styled, TextField } from "@mui/material";
import { forgetPassword } from "app/redux/actions";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { PATH } from "../../../config";


const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
});

const StyledRoot = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#f5f5f5ff",
  minHeight: "100vh !important",

  "& .card": {
    maxWidth: 800,
    margin: "1rem",
    borderRadius: 12,
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)"
  },

  ".img-wrapper": {
    display: "flex",
    padding: "2rem",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ContentBox = styled("div")(({ }) => ({
  padding: 32,

}));

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFormSubmit = (values) => {
    dispatch(forgetPassword({ email: values.email }, moveToNext, moveToFailure));
  };
  const moveToFailure = (message) => {
    toast.error(message);
  };
  const moveToNext = () => {
    toast.success("OTP sent to your registered email!");
    navigate(PATH.RESETPASSWORD);
  }
  return (
    <StyledRoot>
      <Card className="card">
        <Grid container>
          <Grid item xs={12}>
            <div className="img-wrapper">
              <img
                width="300"
                src="/assets/images/technodevs.jpeg"
                alt="Forgot Password Illustration"
              />
            </div>

            <ContentBox>
              <Formik
                initialValues={{ email: "" }}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmit}
              >
                {({ handleSubmit, handleChange, values, errors, touched }) => (
                  <form onSubmit={handleSubmit}>
                    <TextField
                      type="email"
                      name="email"
                      size="small"
                      label="Email"
                      value={values.email}
                      variant="outlined"
                      onChange={handleChange}
                      error={Boolean(errors.email && touched.email)}
                      helperText={touched.email && errors.email}
                      sx={{ mb: 3, width: "100%" }}
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      type="submit"
                    >
                      Forgot Password
                    </Button>

                    <Button
                      fullWidth
                      color="primary"
                      variant="outlined"
                      onClick={() => navigate(-1)}
                      sx={{ mt: 2 }}
                    >
                      Go Back
                    </Button>
                  </form>
                )}
              </Formik>
            </ContentBox>
          </Grid>
        </Grid>
      </Card>
    </StyledRoot>
  );
}
